/* eslint-disable react/no-unescaped-entities */
import React, { useCallback, useEffect, useMemo } from 'react';
import s from './s.module.less';
import {
    EServiceConfigPriceType,
    EServiceType,
    KlarityService,
    KlarityServicePrice,
    KlarityServiceTypeTemplate,
    KlarityServiceTypeValue,
    ServerKlarityService,
    ServerMeta,
    TKlarityProgramItem,
    TKlarityStateTPrice,
} from 'types/common';
import ConfigServiceType from './components/ConfigServiceType';
import {
    BOOK_PROGRAM_WEBINAR_LINK,
    ESpecialty,
    HELP_EMAIL,
    KLAIRTY_TEMPLATE_PRICE_MAP,
    LA_FIRE_SPE_NAME,
    WEIGHT_LOSS_15_MINS_TEMPLATE,
} from 'constants/common';
import { Button, Modal, Popover, Select, Spin, Tooltip } from 'antd';
import useKlarityServicePrice from 'hooks/useKlarityServicePrice';
import { getKlarityPriceAreaFromRecommendPrice } from 'utils/service';
import { ServerData } from 'components/ApplicationFormComponents/KlarityServices/types';
import useGetSettingData from 'hooks/useGetSettingData';
import { EnumFields } from 'types/enumerationData';
import { PracitceAddressForm } from 'types/practiceFront';
import UniprofileStepDataStore from 'store/UniprofileStepData';
import Notes from 'components/Notes';
import commonS from 'styles/common.module.less';
import ProgramConfigIntro from '../ProgramConfigIntro';
import ConfigStatus from 'components/ConfigStatus';
import { Provider, UniprofileFormData } from 'types/provider';
import ProviderStore from 'store/Provider';
import { getHasShowWebinarModal, setHasShowWebinarModal } from 'utils/localstore';
import { IInsurance } from 'types/insurance';
import { ISpecialtiesOptions } from 'types/applicationForm';
import { IPPAServicePriceConfigResponse } from 'types/ppaOnboarding';
import useGetPPAServicePriceConfig from 'hooks/useGetPPAServicePriceConfig';

type IProps = {
    forceEnableStateSelect?: boolean;
    hideAddNew?: boolean;
    disablePriceNDurationEdit?: boolean;
    disableContactTypeEdit?: boolean;
    disablePatientCostEdit?: boolean;
    wrapClassName?: string;
    hideConditions?: boolean;
    hideNeedHelp?: boolean;
    serviceDatas?: KlarityService[];
    serverIdStateMap: Record<string, ServerMeta[]>;
    currentEditingStep: number;
    editingValue?: ServerKlarityService[];
    isEdit?: boolean;
    onUpdate?: (data: ServerData) => void;
    onHasNameErrorUpdate?: (hasError: boolean) => void;
    isOps?: boolean;
    providerId?: number;
    addressList?: PracitceAddressForm[];
    allStatesFromService?: ServerMeta[];
    isLayer?: boolean;
    handleExploreProgram?: () => void;
    programList?: TKlarityProgramItem[];
    errorMedicationFlag?: {};
    isKiwiUser?: boolean;
    uniprofileInsuranceData?: IInsurance[];
    provider?: UniprofileFormData;
    isEditingConditions?: boolean;
    setIsEditingConditions?: (v: boolean) => void;
    forceHideCloseSwitch?: boolean;
    paymentTypeConfig?: {
        cashPay: {
            show: boolean;
            disable: boolean;
        };
        insurancePay: {
            show: boolean;
            disable: boolean;
        };
    };
    allowStatesProps?: ServerMeta[];
    // servicePriceConfig?: IPPAServicePriceConfigResponse[];
    useInsuranceComponent?: boolean;
    forceShowProcess?: boolean;
};

const ConfigService = (props: IProps) => {
    const {
        forceEnableStateSelect,
        hideAddNew,
        hideConditions,
        hideNeedHelp,
        disablePatientCostEdit,
        disablePriceNDurationEdit,
        disableContactTypeEdit,
        serviceDatas = [],
        addressList,
        serverIdStateMap,
        currentEditingStep,
        programList,
        handleExploreProgram,
        onUpdate,
        onHasNameErrorUpdate,
        editingValue,
        isEdit,
        isOps,
        isLayer,
        providerId,
        allStatesFromService,
        errorMedicationFlag,
        isKiwiUser,
        uniprofileInsuranceData,
        provider: uniprofileProvder,
        isEditingConditions,
        setIsEditingConditions,
        wrapClassName,
        paymentTypeConfig,
        forceHideCloseSwitch,
        allowStatesProps,
        // servicePriceConfig,
        useInsuranceComponent,
        forceShowProcess = true,
    } = props;
    const [inxStep, setInxStep] = React.useState(currentEditingStep || 1);
    const [allStates] = useGetSettingData(EnumFields.STATE);
    const [servicePriceConfig, loadingServicePriceConfig] = useGetPPAServicePriceConfig(undefined, isOps);

    // const [pendingAddServiceType, setPendingAddServiceType] = React.useState<string>();
    const [pendingAddServiceOption, setPendingAddServiceOption] = React.useState<any>();
    const [addedServiceTypes, setAddedServiceTypes] = React.useState<KlarityServiceTypeTemplate[]>([]);
    const [getProvider] = ProviderStore.useStore();
    const provider: Provider = getProvider('data') as Provider;

    const pendingServerKlarityServices = React.useRef<ServerKlarityService[]>([]);
    const [pendingServerKlarityServicesFlag, setPendingServerKlarityServicesFlag] = React.useState({});
    const pendingDisabledIds = React.useRef<boolean[]>([]);
    const [pendingDisabledIdsFlag, setPendingDisabledIdsFlag] = React.useState({});

    const [allowStateFromEdit, setAllowStateFromEdit] = React.useState<ServerMeta[]>();
    const [stateFromInitVisit, setStateFromInitVisit] = React.useState<ServerMeta[]>();
    const [showProgramModal, setShowProgramModal] = React.useState<boolean>(false);
    const [programModalShowWebinar, setProgramModalShowWebinar] = React.useState<boolean>(false);

    const [isWeightLoss15Mins, setIsWeightLoss15Mins] = React.useState<boolean>(false);

    // const [minxStateFromInitVisit, setMinxStateFromInitVisit] = React.useState<ServerMeta[]>([]);

    const nameIsExistedError = React.useRef<boolean[]>([]);

    const [get, set] = UniprofileStepDataStore.useStore();
    const configSpeciality = get('speciality');
    const currentSpeciality = get('currentSpeciality');

    const program = programList?.find((item) => item.specialtyName === currentSpeciality);
    const hasProgram = !!program;
    const programEnrolled = hasProgram && program?.enrolled;

    React.useEffect(() => {
        if (hasProgram && programEnrolled && !getHasShowWebinarModal() && !isEdit && !isOps) {
            setHasShowWebinarModal('true');
            setShowProgramModal(true);
        }
    }, [hasProgram, programEnrolled, isEdit, isOps]);

    const { length } = serviceDatas;
    const width = `${((inxStep - 1) / length) * 100}%`;

    const showProgress = serviceDatas.length > 1;

    const current = useMemo(() => {
        return serviceDatas.length >= inxStep ? serviceDatas[inxStep - 1] : undefined;
    }, [inxStep, serviceDatas]);
    const optionServiceTypes = useMemo(() => {
        const serviceTypeNames = current?.serversTypeNames || [];
        if (
            current?.specialtyName === ESpecialty.WEIGHT_LOSS &&
            current &&
            current.serversTypes &&
            current.serversTypes.length > 0
        ) {
            const initialVisitServersType = current.serversTypes.find(
                (item) => item.klarityTemplate === WEIGHT_LOSS_15_MINS_TEMPLATE,
            );
            const initialVisitServicersTypeName = serviceTypeNames.find(
                (item) => item.id === initialVisitServersType?.serviceTypeId,
            );

            if (initialVisitServicersTypeName) {
                return [
                    ...serviceTypeNames,
                    {
                        ...initialVisitServicersTypeName,
                        displayName: '🕒 New patient initial visit (15 min)',
                        klarityTemplate: WEIGHT_LOSS_15_MINS_TEMPLATE,
                        description:
                            'An initial visit with a provider typically includes a medical history review, an assessment of your specific symptoms and concerns, and a visit notes — all completed within a 15-minute session.',
                        // customizedServiceName: 'Consultation and Prescription',
                    },
                ];
            }
        }

        return serviceTypeNames.filter((item) => item.serviceType !== EServiceType.PRESCRIPTION_SERVICE);
    }, [current]);
    //const allConfigingServiceTypes:KlarityServiceTypeTemplate[] = [...(current?.serversTypeNames?.filter((item) => item.serviceType === EServiceType.PRESCRIPTION_SERVICE) || []), ...addedServiceTypes];
    const [allConfigingServiceTypes, setAllConfigingServiceTypes] = React.useState<KlarityServiceTypeTemplate[]>([
        ...(current?.serversTypeNames || []),
        ...addedServiceTypes,
    ]);

    const allItemLength = allConfigingServiceTypes.length || 0;
    const addLength = addedServiceTypes.length || 0;

    const isLaFireSpe = LA_FIRE_SPE_NAME?.toLowerCase() === currentSpeciality?.toLowerCase();
    const supportAddNew = !isLaFireSpe && !hideAddNew;

    const [pendingSelectedConditions, setPendingSelectedConditions] = React.useState<string[]>([]);
    const [selectedCondtions, setSelectedCondtions] = React.useState<string[]>([]);
    const [conditionsOptions, setConditionsOptions] = React.useState<string[]>([]);

    useEffect(() => {
        if (current) {
            const conditions = (current?.providerConditions || current?.commonCondition || '').split(',');
            setSelectedCondtions(conditions);
            setPendingSelectedConditions(conditions);
            setConditionsOptions(current?.commonCondition?.split(',') || []);
        }
    }, [current]);
    // const conditions = useMemo(() => {
    //     if (current && current?.commonCondition) {
    //         return current?.commonCondition.split(',');
    //     }
    //     return [];
    // }, [current]);

    React.useEffect(() => {
        if (current) {
            set('currentSpeciality', current?.specialtyName);
        }
    }, [current]);

    React.useEffect(() => {
        let _allConfigingServiceTypes: KlarityServiceTypeTemplate[] = [];
        if (isEdit && editingValue) {
            editingValue.forEach((item) => {
                const template = current?.serversTypeNames?.find((i) => i.serviceType === item.serviceType);
                if (template) {
                    if (
                        !isKiwiUser &&
                        item?.serviceSpecialtyName === ESpecialty.WEIGHT_LOSS &&
                        item?.serviceType === EServiceType.INIT &&
                        item?.klarityTemplate === WEIGHT_LOSS_15_MINS_TEMPLATE
                    ) {
                        _allConfigingServiceTypes.push({
                            ...template,
                            displayName: '🕒 New patient initial visit (15 min)',
                            klarityTemplate: WEIGHT_LOSS_15_MINS_TEMPLATE,
                            description:
                                'An initial visit with a provider typically includes a medical history review, an assessment of your specific symptoms and concerns, and a visit notes — all completed within a 15-minute session.',
                            // customizedServiceName: 'Consultation and Prescription',
                        });
                    } else {
                        _allConfigingServiceTypes.push(template);
                    }
                } else if (current?.serversTypeNames && current?.serversTypeNames?.length > 0) {
                    //not find template
                    _allConfigingServiceTypes.push({ ...current?.serversTypeNames[0], displayName: 'Others' });
                }
            });
            //_allConfigingServiceTypes = _allConfigingServiceTypes.filter((item) => item.serviceType === EServiceType.ESTABLISHED_PATIENT_VISIT);
            _allConfigingServiceTypes = [..._allConfigingServiceTypes, ...addedServiceTypes];
        }

        if (current?.savedValue && current?.savedValue.length > 0) {
            //not need?
            current?.savedValue.forEach((item) => {
                const template = current?.serversTypeNames?.find((i) => i.serviceType === item.serviceType);
                if (template) {
                    _allConfigingServiceTypes.push(template);
                } else if (current?.serversTypeNames && current?.serversTypeNames?.length > 0) {
                    _allConfigingServiceTypes.push({ ...current?.serversTypeNames[0] });
                }
            });
            _allConfigingServiceTypes = [..._allConfigingServiceTypes, ...addedServiceTypes];
        }
        if (_allConfigingServiceTypes.length === 0) {
            _allConfigingServiceTypes = [...(current?.serversTypeNames || []), ...addedServiceTypes];
            if (!isKiwiUser && current?.specialtyName === ESpecialty.WEIGHT_LOSS) {
                const originalInitialVisitServiceTypeName = current?.serversTypeNames?.find(
                    (item) => item.serviceType === EServiceType.INIT,
                );
                const initialVisit15MinsTemplateData = current?.serversTypes?.find(
                    (item) => item.klarityTemplate === WEIGHT_LOSS_15_MINS_TEMPLATE,
                );
                if (initialVisit15MinsTemplateData && originalInitialVisitServiceTypeName) {
                    _allConfigingServiceTypes.push({
                        ...originalInitialVisitServiceTypeName,
                        displayName: '🕒 New patient initial visit (15 min)',
                        klarityTemplate: WEIGHT_LOSS_15_MINS_TEMPLATE,
                        description:
                            'An initial visit with a provider typically includes a medical history review, an assessment of your specific symptoms and concerns, and a visit notes — all completed within a 15-minute session.',
                        // customizedServiceName: 'Consultation and Prescription',
                    });
                }
            }
        }
        if (addedServiceTypes.length === 0) {
            pendingServerKlarityServices.current = pendingServerKlarityServices.current?.slice(
                0,
                _allConfigingServiceTypes.length,
            );
        }
        setAllConfigingServiceTypes(_allConfigingServiceTypes);
    }, [current, addedServiceTypes, isKiwiUser, isEdit, editingValue]);

    const allowStates = serverIdStateMap[`${current?.id}`];

    let choosedStates = isEdit ? allowStateFromEdit : allowStates;
    if (isEdit && stateFromInitVisit && stateFromInitVisit.length > 0) {
        choosedStates = stateFromInitVisit;
    }
    // if (isKiwiUser) {
    //     choosedStates = allStates as ServerMeta[];
    // }

    const [allStateConfigTypePriceData, setAllStateConfigTypePriceData] =
        React.useState<Record<string, TKlarityStateTPrice>>();
    const [klarityServicePriceData, loading] = useKlarityServicePrice(
        current?.specialtyName,
        allStatesFromService?.map((item) => item.content),
        isOps,
        providerId,
    );
    //console.log(JSON.stringify(klarityServicePriceData));

    React.useEffect(() => {
        if (editingValue) {
            const stateKeys: string[] = [];
            editingValue.forEach((item) => {
                item?.serviceStateItems?.forEach((stateItem) => {
                    if (!stateKeys.includes(stateItem.state)) {
                        stateKeys.push(stateItem.state);
                    }
                });
            });
            // pendingServerKlarityServices.current = [];
            // pendingDisabledIds.current = [];
            const statesFromEdit = (allStates as ServerMeta[])?.filter((state: ServerMeta) =>
                stateKeys.includes(state.dictKey),
            );
            setAllowStateFromEdit(statesFromEdit);
        }
    }, [editingValue]);

    React.useEffect(() => {
        if (currentEditingStep === inxStep) {
            return;
        }
        setInxStep(currentEditingStep);
        nameIsExistedError.current = [];
        pendingServerKlarityServices.current = [];
        pendingDisabledIds.current = [];
        setAddedServiceTypes([]);
    }, [currentEditingStep, inxStep]);

    const handleGetPricesNRange = (v: number = 0, state?: string) => {
        const _statePriceMap: Record<string, TKlarityStateTPrice> = {};
        const allStateContent: string[] = [];
        const krcPriceItem: KlarityServicePrice[] = klarityServicePriceData?.[EServiceConfigPriceType.KRC] || [];
        const marketingMarkupPriceItem: KlarityServicePrice[] =
            klarityServicePriceData?.[EServiceConfigPriceType.MARKETING_MARKUP] || [];
        const platformFeePriceItem: KlarityServicePrice[] =
            klarityServicePriceData?.[EServiceConfigPriceType.PLATFORM_FEE] || [];
        krcPriceItem.forEach((item) => {
            if (!allStateContent.includes(item.state)) {
                allStateContent.push(item.state);
            }
        });

        allStateContent.forEach((stateContent: string) => {
            const floatPrice = state && stateContent === state ? v : 0;
            const data: TKlarityStateTPrice = {
                [EServiceType.INIT]: {},
                [EServiceType.CONSULTATION]: {},
                [EServiceType.ESTABLISHED_PATIENT_VISIT]: {},
                [EServiceType.PRESCRIPTION_SERVICE]: {},
                [EServiceType.OTHER_PATIENT_SUPPORT]: {},
                [EServiceType.CONSULTATION_OVERCHARGE]: {},
                [EServiceType.MEDICATIONS]: {}, //todo
                [WEIGHT_LOSS_15_MINS_TEMPLATE]: {},
            };
            const krcPrice = krcPriceItem.find((item) => item.state === stateContent);
            data[EServiceType.INIT]!.krc = krcPrice?.newPatientInitialVisit || 0;
            data[EServiceType.CONSULTATION]!.krc = krcPrice?.consultation || 0;
            data[EServiceType.ESTABLISHED_PATIENT_VISIT]!.krc = krcPrice?.establishedPatientFollowUpVisit || 0;
            data[EServiceType.PRESCRIPTION_SERVICE]!.krc = krcPrice?.prescriptionService || 0;
            data[EServiceType.OTHER_PATIENT_SUPPORT]!.krc = krcPrice?.documentationSupport || 0;
            data[EServiceType.MEDICATIONS]!.krc = krcPrice?.medications || 0;

            data[WEIGHT_LOSS_15_MINS_TEMPLATE]!.krc =
                KLAIRTY_TEMPLATE_PRICE_MAP[
                    WEIGHT_LOSS_15_MINS_TEMPLATE as keyof typeof KLAIRTY_TEMPLATE_PRICE_MAP
                ].patientCost;
            data[EServiceType.CONSULTATION_OVERCHARGE]!.krc = krcPrice?.consultation || 0;

            const mmuPrice = marketingMarkupPriceItem.find((item) => item.state === stateContent);
            data[EServiceType.INIT]!.mmu = mmuPrice?.newPatientInitialVisit || 0;
            data[EServiceType.CONSULTATION]!.mmu = mmuPrice?.consultation || 0;
            data[EServiceType.ESTABLISHED_PATIENT_VISIT]!.mmu = mmuPrice?.establishedPatientFollowUpVisit || 0;
            data[EServiceType.PRESCRIPTION_SERVICE]!.mmu = mmuPrice?.prescriptionService || 0;
            data[EServiceType.OTHER_PATIENT_SUPPORT]!.mmu = mmuPrice?.documentationSupport || 0;
            data[EServiceType.MEDICATIONS]!.mmu = mmuPrice?.medications || 0;

            data[WEIGHT_LOSS_15_MINS_TEMPLATE]!.mmu =
                KLAIRTY_TEMPLATE_PRICE_MAP[
                    WEIGHT_LOSS_15_MINS_TEMPLATE as keyof typeof KLAIRTY_TEMPLATE_PRICE_MAP
                ].marketingMarkUp;

            data[EServiceType.CONSULTATION_OVERCHARGE]!.mmu = mmuPrice?.consultation;

            const pfPrice = platformFeePriceItem.find((item) => item.state === stateContent);
            data[EServiceType.INIT]!.pf = pfPrice?.newPatientInitialVisit || 0;
            data[EServiceType.CONSULTATION]!.pf = pfPrice?.consultation || 0;
            data[EServiceType.ESTABLISHED_PATIENT_VISIT]!.pf = pfPrice?.establishedPatientFollowUpVisit || 0;
            data[EServiceType.PRESCRIPTION_SERVICE]!.pf = pfPrice?.prescriptionService || 0;
            data[EServiceType.OTHER_PATIENT_SUPPORT]!.pf = pfPrice?.documentationSupport || 0;
            data[EServiceType.MEDICATIONS]!.pf = pfPrice?.medications || 0;

            data[WEIGHT_LOSS_15_MINS_TEMPLATE]!.pf =
                KLAIRTY_TEMPLATE_PRICE_MAP[
                    WEIGHT_LOSS_15_MINS_TEMPLATE as keyof typeof KLAIRTY_TEMPLATE_PRICE_MAP
                ].platformFee;

            data[EServiceType.CONSULTATION_OVERCHARGE]!.pf = pfPrice?.newPatientInitialVisit || 0;
            _statePriceMap[stateContent] = data;

            // 只有initial 和 establish 需要按时间增加价格
            const initTotal =
                (krcPrice?.newPatientInitialVisit || 0) +
                floatPrice +
                (mmuPrice?.newPatientInitialVisit || 0) +
                (pfPrice?.newPatientInitialVisit || 0);
            const consultationTotal =
                (krcPrice?.consultation || 0) + (mmuPrice?.consultation || 0) + (pfPrice?.consultation || 0);
            const establishedTotal =
                (krcPrice?.establishedPatientFollowUpVisit || 0) +
                floatPrice +
                (mmuPrice?.establishedPatientFollowUpVisit || 0) +
                (pfPrice?.establishedPatientFollowUpVisit || 0);
            const prescriptionServiceTotal =
                (krcPrice?.prescriptionService || 0) +
                (mmuPrice?.prescriptionService || 0) +
                (pfPrice?.prescriptionService || 0);
            const documentationSupportTotal =
                (krcPrice?.documentationSupport || 0) +
                (mmuPrice?.documentationSupport || 0) +
                (pfPrice?.documentationSupport || 0);
            const medicationsTotal =
                (krcPrice?.medications || 0) + (mmuPrice?.medications || 0) + (pfPrice?.medications || 0);

            const consultationOverchargeTotal =
                (krcPrice?.consultation || 0) +
                floatPrice +
                (mmuPrice?.consultation || 0) +
                (pfPrice?.newPatientInitialVisit || 0);

            data[EServiceType.INIT]!.recommendPriceArea = getKlarityPriceAreaFromRecommendPrice(initTotal);
            data[EServiceType.CONSULTATION]!.recommendPriceArea =
                getKlarityPriceAreaFromRecommendPrice(consultationTotal);
            data[EServiceType.ESTABLISHED_PATIENT_VISIT]!.recommendPriceArea =
                getKlarityPriceAreaFromRecommendPrice(establishedTotal);
            data[EServiceType.PRESCRIPTION_SERVICE]!.recommendPriceArea =
                getKlarityPriceAreaFromRecommendPrice(prescriptionServiceTotal);
            data[EServiceType.OTHER_PATIENT_SUPPORT]!.recommendPriceArea =
                getKlarityPriceAreaFromRecommendPrice(documentationSupportTotal);
            data[EServiceType.MEDICATIONS]!.recommendPriceArea =
                getKlarityPriceAreaFromRecommendPrice(medicationsTotal);
            data[EServiceType.CONSULTATION_OVERCHARGE]!.recommendPriceArea =
                getKlarityPriceAreaFromRecommendPrice(consultationOverchargeTotal);

            data[WEIGHT_LOSS_15_MINS_TEMPLATE]!.recommendPriceArea = getKlarityPriceAreaFromRecommendPrice(initTotal);
        });

        return _statePriceMap;
    };

    const generatePrices = (v: number = 0, state?: string) => {
        const newAllStateConfigTypePriceData = handleGetPricesNRange(v, state);
        setAllStateConfigTypePriceData(newAllStateConfigTypePriceData);
    };

    React.useEffect(() => {
        generatePrices();
    }, [klarityServicePriceData]);

    React.useEffect(() => {
        const max = allConfigingServiceTypes.length;
        const disableIds = pendingDisabledIds.current
            .map((isDisabled, inx) => {
                if (isDisabled && inx < max) {
                    if (
                        pendingServerKlarityServices.current.length > inx &&
                        pendingServerKlarityServices.current[inx]
                    ) {
                        return pendingServerKlarityServices.current[inx].serviceId;
                    }
                }
                return 0;
            })
            .filter(Boolean);
        const filteredPendingServerKlarityServices = pendingServerKlarityServices.current.filter((item, inx) => {
            if (pendingDisabledIds && pendingDisabledIds.current.length > inx) {
                if (pendingDisabledIds.current[inx]) {
                    return false;
                }
            }
            if (inx > max) {
                return false;
            }
            return true;
        });
        // console.log({
        //     max,
        //     pendingDisabledIds,
        //     disableIds,
        //     filteredPendingServerKlarityServices,
        //     pendingServerKlarityServices
        // })
        const data: ServerData = {
            providerKlarityService: filteredPendingServerKlarityServices,
            disableIds,
            conditions: selectedCondtions,
            allSeted: filteredPendingServerKlarityServices.length === max,
        };

        let hasEditingNameError = false;

        const allNames: string[] = [];
        filteredPendingServerKlarityServices.forEach((item: ServerKlarityService) => {
            const orgTemplate = current?.serversTypeNames?.find((i) => i.serviceType === item.serviceType);
            const name = `${item?.serviceSpecialtyName}${item?.customizedServiceName || ''}${orgTemplate?.displayName}`;
            if (allNames.includes(name)) {
                hasEditingNameError = true;
            }
            allNames.push(name);
        });
        const hasServerNameError = nameIsExistedError.current.filter((val) => !!val).length > 0;
        onHasNameErrorUpdate?.(hasEditingNameError || hasServerNameError);
        onUpdate?.(data);
    }, [
        allConfigingServiceTypes.length,
        pendingServerKlarityServicesFlag,
        pendingDisabledIdsFlag,
        pendingAddServiceOption,
        selectedCondtions,
    ]);

    const allNames: string[] = [];
    pendingServerKlarityServices.current.forEach((item: ServerKlarityService, inx) => {
        if (pendingDisabledIds.current.length > inx && pendingDisabledIds.current[inx]) {
            return;
        }
        const orgTemplate = current?.serversTypeNames?.find((i) => i.serviceType === item.serviceType);
        const name = `${item?.serviceSpecialtyName}${item?.customizedServiceName || ''}${orgTemplate?.displayName}`;
        allNames.push(name);
    });

    const handleInitVisitStateChange = (states: ServerMeta[]) => {
        if (states && states.length > 0) {
            setStateFromInitVisit(states);
            // setMinxStateFromInitVisit(Array.from(new Set([...states, ...minxStateFromInitVisit])));
        }
    };

    const singleServiceStatus: 'default' | 'configing' | 'selected' = 'configing';
    const programStatus: 'default' | 'configing' | 'selected' = programEnrolled ? 'selected' : 'default';
    //const showProgramModule = isLayer && !!(currentSpeciality && configSpecialitySelectedProgram);

    const handleClickCondition = useCallback(
        (condition: string) => {
            let newPendingSelectedConditions = [...pendingSelectedConditions];
            if (newPendingSelectedConditions.includes(condition)) {
                newPendingSelectedConditions = newPendingSelectedConditions.filter((item) => item !== condition);
            } else {
                newPendingSelectedConditions.push(condition);
            }
            setPendingSelectedConditions(newPendingSelectedConditions);
        },
        [pendingSelectedConditions],
    );

    const handleSaveConditions = useCallback(() => {
        setSelectedCondtions(pendingSelectedConditions);
        setIsEditingConditions?.(false);
    }, [pendingSelectedConditions, setIsEditingConditions]);

    const conditionsRender = useMemo(() => {
        const conditionsArray = selectedCondtions || [];
        const maxLength = 8;
        const safeIndex = Math.min(maxLength, conditionsArray.length);
        const displayCondition = conditionsArray?.slice(0, safeIndex) || [];
        const moreCondition = conditionsArray?.slice(safeIndex) || [];
        const hasMoreCondition = moreCondition.length > 0;
        return (
            <div className={s.conditions}>
                <div className={s.conditionHeader}>
                    <div className={s.conditionTitle}>Conditions</div>
                    <div className={s.btns}>
                        {isEditingConditions ? (
                            <>
                                <Button
                                    onClick={() => {
                                        setIsEditingConditions?.(false);
                                        setPendingSelectedConditions(selectedCondtions);
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button type="primary" onClick={handleSaveConditions}>
                                    Save changes
                                </Button>
                            </>
                        ) : (
                            <Button onClick={() => setIsEditingConditions?.(true)}>Edit</Button>
                        )}
                    </div>
                </div>
                {!isEditingConditions ? (
                    <div className={s.conditionTagsWrap}>
                        <div className={s.conditionTags}>
                            {displayCondition?.map((item) => {
                                return <div className={s.conditionTag}>{item}</div>;
                            })}
                        </div>
                        {hasMoreCondition && (
                            <Tooltip
                                overlayClassName={s.tipCard}
                                overlayInnerStyle={{ padding: '12px' }}
                                color="#FFFFFF"
                                title={<div className={s.toolWrap}>{moreCondition?.join(', ')}</div>}
                                trigger="hover"
                            >
                                <div className={s.more}>{moreCondition.length} more</div>
                            </Tooltip>
                        )}
                    </div>
                ) : (
                    <div className={s.conditionEditingBox}>
                        <div className={s.selectedConditions}>
                            {pendingSelectedConditions?.map((condition) => {
                                return (
                                    <div
                                        className={`${s.conditionTag} ${s.conditionTagActive}`}
                                        onClick={() => handleClickCondition(condition)}
                                    >
                                        {condition}
                                    </div>
                                );
                            })}
                        </div>
                        <div className={s.unSelectedConditions}>
                            {conditionsOptions
                                ?.filter((item) => !pendingSelectedConditions?.includes(item))
                                .map((condition) => {
                                    return (
                                        <div className={s.conditionTag} onClick={() => handleClickCondition(condition)}>
                                            {condition}
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                )}
            </div>
        );
    }, [
        selectedCondtions,
        isEditingConditions,
        handleSaveConditions,
        pendingSelectedConditions,
        conditionsOptions,
        setIsEditingConditions,
        handleClickCondition,
    ]);

    const showProgramModule = isLayer && hasProgram && !programEnrolled;

    if (isEdit && !editingValue) {
        return (
            <div className={s.wrap}>
                <Spin
                    style={{
                        height: '500px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                />
            </div>
        );
    }

    const handleOpenCalendarInModal = () => {
        setProgramModalShowWebinar(true);
        setTimeout(() => {
            const objString = new URLSearchParams({
                hide_gdpr_banner: '1',
                first_name: provider?.firstName,
                last_name: provider?.lastName,
            }).toString();

            (window as any).Calendly.initInlineWidget({
                url: `${BOOK_PROGRAM_WEBINAR_LINK}?${objString}`,
                // url: `https://calendly.com/kunqian-fan/11?${objString}`,
                parentElement: document.getElementById('calendly'),
                prefill: {
                    email: provider?.email,
                },
            });
        }, 300);
    };

    return (
        <div className={`${s.wrap} ${isLayer ? s.wrapLayer : ''} ${wrapClassName}`}>
            {isLayer && (
                <div className={s.title}>
                    <div className={s.titleTop}>
                        <span className={s.icon}>
                            {currentSpeciality === 'Telehealth visit & prescription refill' ? (
                                <svg
                                    width="32"
                                    height="29"
                                    viewBox="0 0 32 29"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect width="31.3" height="29" rx="2.57778" fill="#D1E9FF" />
                                    <g clipPath="url(#clip0_14158_96603)">
                                        <path
                                            d="M26.6237 6.18136L26.6237 6.18137C27.8796 7.12132 28.6417 8.47604 28.5845 10.0018C28.4148 14.528 24.9971 18.684 22.2186 21.0233L22.2186 21.0233C20.851 22.175 19.4073 23.2421 17.9171 24.2401L17.917 24.2401C17.8826 24.2632 17.8002 24.3241 17.6945 24.4023C17.6606 24.4273 17.6244 24.4541 17.5865 24.482C17.4249 24.6011 17.2223 24.7493 17.0165 24.8938C16.8098 25.039 16.6038 25.1777 16.4345 25.2793C16.3716 25.3171 16.3164 25.3481 16.2699 25.3719L16.1206 25.1011L15.9713 25.3719C15.9248 25.3481 15.8696 25.3171 15.8067 25.2793C15.6375 25.1777 15.4314 25.039 15.2248 24.8938C15.0189 24.7493 14.8164 24.6011 14.6547 24.482C14.6168 24.454 14.5805 24.4272 14.5466 24.4022C14.4409 24.324 14.3586 24.2632 14.3242 24.2401L14.324 24.24C12.8339 23.2422 11.3903 22.175 10.0226 21.0233L10.0226 21.0233C8.64586 19.8642 7.09459 18.1278 5.90867 16.1667C4.72072 14.2022 3.91565 12.0394 3.99121 10.0214L3.99157 10.0116L3.99121 10.0018C3.93414 8.47606 4.69632 7.12146 5.95213 6.18136C7.35536 5.13094 9.21552 4.938 11.0669 5.27891C12.9167 5.61954 14.7182 6.48716 15.963 7.50042L16.0351 7.55916H16.1282H16.2287H16.3217L16.3939 7.50043C17.6366 6.48889 19.4918 5.62032 21.3982 5.27915C23.3073 4.93748 25.2216 5.13174 26.6237 6.18136Z"
                                            fill="#D93829"
                                            stroke="black"
                                            strokeWidth="0.523391"
                                        />
                                        <path
                                            d="M20.1804 18.9371L20.2559 16.9628H18.1558L17.5396 18.9371H15.1377L18.3696 9.88281H22.5195L22.5698 18.9371H20.1804ZM19.6649 12.0835L18.6714 15.2777H20.3188L20.4571 12.0835H19.6649Z"
                                            fill="white"
                                        />
                                        <path
                                            d="M14.6973 18.9371H8.96289L10.56 9.88281H12.8235L11.5786 16.9754H15.0494L14.6973 18.9371Z"
                                            fill="white"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_14158_96603">
                                            <rect
                                                width="25.7778"
                                                height="25.7778"
                                                fill="white"
                                                transform="translate(3.08398 1.93359)"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>
                            ) : (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="31"
                                    height="30"
                                    viewBox="0 0 31 30"
                                    fill="none"
                                >
                                    <path
                                        d="M18.2856 5.63867L18.3447 5.52042C18.7664 4.67614 19.4113 3.96272 20.2106 3.45741C21.0313 2.93791 21.9804 2.66357 22.954 2.66357C25.7935 2.66357 28.1032 4.97333 28.1032 7.81284C28.1032 9.89872 26.8561 11.7655 24.9263 12.5695L24.8057 12.62L24.3926 12.7666L24.1136 12.8313C23.7352 12.9188 23.3457 12.9629 22.954 12.9629C20.1144 12.9629 17.8047 10.6531 17.8047 7.81363C17.8047 7.30202 17.8804 6.79592 18.0286 6.30953L18.1113 6.03914L18.2848 5.63867H18.2856Z"
                                        fill="black"
                                    />
                                    <path
                                        d="M20.7138 11.4955C20.7492 11.4955 20.7847 11.5049 20.8162 11.5231C20.9148 11.5798 20.9487 11.706 20.8919 11.8045L20.7682 12.0189L20.9723 12.1135C21.4642 12.3413 21.9869 12.4817 22.5277 12.5305L22.7523 12.551V11.9322C22.7523 11.8187 22.8446 11.7265 22.9581 11.7265C23.0716 11.7265 23.1638 11.8187 23.1638 11.9322V12.551L23.3885 12.5305C23.9293 12.4817 24.4527 12.3413 24.9439 12.1135L25.1488 12.0189L25.0251 11.8045C24.9683 11.7067 25.0022 11.5798 25.1007 11.5231C25.1323 11.5049 25.167 11.4955 25.2032 11.4955C25.2765 11.4955 25.3451 11.5349 25.3822 11.5987L25.5059 11.8124L25.6904 11.6815C26.1326 11.3686 26.515 10.9862 26.8279 10.544L26.958 10.3595L26.7444 10.2358C26.6458 10.179 26.6119 10.0529 26.6687 9.95432C26.7057 9.89047 26.7735 9.85106 26.8476 9.85106C26.8839 9.85106 26.9186 9.86051 26.9501 9.87865L27.1645 10.0024L27.2591 9.79824C27.487 9.30633 27.6273 8.78368 27.6762 8.24289L27.6967 8.01822H27.0778C26.9643 8.01822 26.8721 7.92599 26.8721 7.81247C26.8721 7.69896 26.9643 7.60673 27.0778 7.60673H27.6967L27.6762 7.38206C27.6273 6.84127 27.487 6.31783 27.2591 5.82671L27.1645 5.62254L26.9501 5.7463C26.9186 5.76443 26.8831 5.77389 26.8476 5.77389C26.7743 5.77389 26.7057 5.73448 26.6687 5.67063C26.6119 5.57209 26.6458 5.44596 26.7444 5.3892L26.958 5.26543L26.8271 5.08097C26.5142 4.63872 26.1318 4.25639 25.6896 3.94343L25.5051 3.81257L25.3814 4.0262C25.3443 4.09006 25.2765 4.12947 25.2024 4.12947C25.1662 4.12947 25.1315 4.12001 25.0999 4.10188C25.0014 4.04512 24.9675 3.91899 25.0243 3.82045L25.148 3.60682L24.9431 3.51222C24.4512 3.2844 23.9285 3.14408 23.3877 3.0952L23.1631 3.07471V3.69353C23.1631 3.80705 23.0708 3.89928 22.9573 3.89928C22.8438 3.89928 22.7516 3.80705 22.7516 3.69353V3.07471L22.5269 3.0952C21.9861 3.14408 21.4627 3.2844 20.9715 3.51222L20.7674 3.60682L20.8911 3.82124C20.9479 3.91978 20.914 4.04591 20.8155 4.10267C20.7839 4.1208 20.7485 4.13026 20.713 4.13026C20.6397 4.13026 20.5711 4.09084 20.534 4.02699L20.4103 3.81336L20.2258 3.94422C19.7836 4.25718 19.4012 4.63951 19.0883 5.08175L18.9574 5.26622L19.171 5.3892C19.2696 5.44596 19.3035 5.57209 19.2467 5.67063C19.2097 5.73448 19.1419 5.77389 19.0678 5.77389C19.0315 5.77389 18.9968 5.76443 18.9653 5.7463L18.7509 5.62254L18.6563 5.82671C18.4284 6.31862 18.2881 6.84127 18.2392 7.38206L18.2188 7.60673H18.8376C18.9511 7.60673 19.0433 7.69896 19.0433 7.81247C19.0433 7.92599 18.9511 8.01822 18.8376 8.01822H18.2188L18.2392 8.24289C18.2881 8.78368 18.4284 9.30633 18.6563 9.79824L18.7509 10.0024L18.9653 9.87865C18.9968 9.86051 19.0315 9.85106 19.0678 9.85106C19.1411 9.85106 19.2097 9.89047 19.2467 9.95432C19.3035 10.0529 19.2696 10.179 19.171 10.2358L18.9574 10.3587L19.0883 10.5432C19.4012 10.9854 19.7836 11.3678 20.2258 11.6807L20.4103 11.8116L20.534 11.598C20.5711 11.5341 20.6389 11.4947 20.713 11.4947L20.7138 11.4955Z"
                                        fill="#FFCD1A"
                                    />
                                    <path
                                        d="M22.8933 8.53472C22.7797 8.53472 22.6875 8.44249 22.6875 8.32897V5.85761C22.6875 5.74409 22.7797 5.65186 22.8933 5.65186C23.0068 5.65186 23.099 5.74409 23.099 5.85761V8.12322H24.5408C24.6543 8.12322 24.7466 8.21545 24.7466 8.32897C24.7466 8.44249 24.6543 8.53472 24.5408 8.53472H22.8933Z"
                                        fill="black"
                                    />
                                    <rect
                                        x="5.32812"
                                        y="6.40576"
                                        width="17.4635"
                                        height="19.3346"
                                        rx="1.87109"
                                        fill="#93C1F9"
                                    />
                                    <path
                                        d="M17.8027 13.2663H10.6302L9.38281 11.0833L9.69466 10.4596C13.1874 7.4659 17.179 9.21225 18.7382 10.4596L19.0501 11.0833L17.8027 13.2663Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M22.9864 19.9734V23.3632C22.9864 24.5772 22.0018 25.5618 20.7878 25.5618H7.52673C6.31273 25.5618 5.32812 24.5772 5.32812 23.3632V8.60437C5.32812 7.39037 6.31273 6.40576 7.52673 6.40576H20.7878C22.0018 6.40576 22.9864 7.39037 22.9864 8.60437V15.0094"
                                        stroke="black"
                                        strokeWidth="0.472989"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        d="M22.9844 17.6787V17.6961"
                                        stroke="black"
                                        strokeWidth="0.472989"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        d="M10.5484 13.1682C10.6359 13.3251 10.8015 13.4221 10.9804 13.4221H17.3326C17.514 13.4221 17.6803 13.3227 17.767 13.1635L18.9045 11.0713C18.9779 10.9365 18.9455 10.7686 18.8273 10.6708C17.8774 9.88883 13.6977 6.8885 9.44477 10.6693C9.33204 10.7694 9.30287 10.9349 9.37618 11.0666L10.5476 13.1682H10.5484Z"
                                        stroke="black"
                                        strokeWidth="0.472989"
                                        strokeMiterlimit="10"
                                    />
                                    <path
                                        d="M14.1562 10.5049V13.4216"
                                        stroke="black"
                                        strokeWidth="0.472989"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        d="M11.4766 10.8989L12.1072 12.1602"
                                        stroke="black"
                                        strokeWidth="0.472989"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        d="M16.7635 10.8989L16.1328 12.1602"
                                        stroke="black"
                                        strokeWidth="0.472989"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            )}
                        </span>
                        <span>{currentSpeciality}</span>
                        {hasProgram && !isKiwiUser && (
                            <span className={`${s.tTab}`}>
                                <ConfigStatus status={programStatus} />
                                Klarity select program
                            </span>
                        )}
                        <span className={`${s.tTab} ${s.tTabActive}`}>
                            <ConfigStatus status={singleServiceStatus} />
                            Single service sessions
                        </span>
                    </div>
                    <div className={s.titleDes} dangerouslySetInnerHTML={{ __html: current?.description || '' }} />
                    {conditionsRender}
                </div>
            )}
            {showProgramModule && !isKiwiUser && (
                <div className={s.programWrap}>
                    <Notes
                        icon={<span>💡</span>}
                        iconClassName={s.expIcon}
                        des={
                            <div>
                                <p>
                                    Would you like to explore the Klarity-designed Weight Loss Program with the Supply
                                    of compounding Semaglutide?
                                </p>
                                <p>
                                    Check out <b>Klarity Select {currentSpeciality} Program</b> and add it in your
                                    Practice!
                                </p>
                            </div>
                        }
                        buttonElement={
                            <Button onClick={handleExploreProgram} className={s.expBtn}>
                                Explore
                            </Button>
                        }
                    />
                </div>
            )}
            {forceShowProcess && (!hideNeedHelp || showProgress) && (
                <div className={s.topBar}>
                    <div className={s.left}>
                        {showProgress && (
                            <>
                                <div className={s.text}>
                                    {inxStep - 1}/{serviceDatas.length} completed
                                </div>
                                <div className={s.bar}>
                                    <div className={s.barIn} style={{ width }} />
                                </div>
                            </>
                        )}
                    </div>
                    {!hideNeedHelp && (
                        <div className={s.tips}>
                            Need Help? Email <a href={`mailto:${HELP_EMAIL}`}>{HELP_EMAIL}</a>
                        </div>
                    )}
                </div>
            )}
            {isLayer && (
                <>
                    <div className={s.subTitle}>Services</div>
                    {isLaFireSpe && (
                        <div className={s.subDes}>
                            * To keep care affordable for patients in LA impacted by the wildfires, most values in this
                            service are fixed. Patient group and Limitations can still be edited.
                        </div>
                    )}
                </>
            )}
            <div className={s.content}>
                <div className={s.title}>
                    <img src={current?.iconUrl} />
                    <span>{current?.specialtyName}</span>
                </div>
                <div className={s.titleDes} dangerouslySetInnerHTML={{ __html: current?.description || '' }} />
                {!isLayer && !hideConditions && conditionsRender}
                {!isLayer && (
                    <>
                        <div className={s.subTitleM}>Services</div>
                        {isLaFireSpe && (
                            <div className={s.subDesM}>
                                * To keep care affordable for patients in LA impacted by the wildfires, most values in
                                this service are fixed. Patient group and Limitations can still be edited.
                            </div>
                        )}
                    </>
                )}
                <div className={s.itemWrap}>
                    {allConfigingServiceTypes?.map((item: KlarityServiceTypeTemplate, inx) => {
                        const key = `${item.displayName + inx}`;
                        const value = current?.serversTypes?.find((i: KlarityServiceTypeValue) => {
                            if (item.klarityTemplate) {
                                return i.klarityTemplate === item.klarityTemplate;
                            }
                            return i.serviceTypeId === item.id;
                        });
                        let editValue: ServerKlarityService | undefined;
                        if (isEdit && editingValue && editingValue.length > inx) {
                            editValue = editingValue[inx];
                        }
                        if (current?.savedValue && current?.savedValue.length > inx) {
                            editValue = current?.savedValue[inx];
                        }
                        let defaultOpen = false;
                        if (inx === 0) {
                            defaultOpen = true;
                        }
                        if (!editValue && inx >= (current?.serversTypeNames?.length || 0)) {
                            defaultOpen = true;
                        }
                        const isAdd = allItemLength - inx <= addLength;
                        const isWeightLoss15MinsService =
                            !isKiwiUser &&
                            current?.specialtyName === ESpecialty.WEIGHT_LOSS &&
                            item?.serviceType === EServiceType.INIT &&
                            item?.klarityTemplate === WEIGHT_LOSS_15_MINS_TEMPLATE;

                        let paymentConfig;
                        if (isWeightLoss15MinsService) {
                            paymentConfig = {
                                cashPay: {
                                    show: true,
                                    disable: true,
                                },
                                insurancePay: {
                                    show: false,
                                    disable: true,
                                },
                            };
                        }

                        return (
                            <div className={s.configTypeItem} key={`${key}_${current?.specialtyName}`}>
                                <ConfigServiceType
                                    forceHideCloseSwitch={forceHideCloseSwitch}
                                    klarityTemplate={
                                        isWeightLoss15MinsService ? WEIGHT_LOSS_15_MINS_TEMPLATE : undefined
                                    }
                                    paymentTypeConfig={paymentConfig || paymentTypeConfig}
                                    forceEnableStateSelect={forceEnableStateSelect}
                                    disablePriceNDurationEdit={disablePriceNDurationEdit || isWeightLoss15MinsService}
                                    disableContactTypeEdit={disableContactTypeEdit || isWeightLoss15MinsService}
                                    disablePatientCostEdit={disablePatientCostEdit || isWeightLoss15MinsService}
                                    provider={uniprofileProvder}
                                    stateFromInitVisit={stateFromInitVisit}
                                    uniprofileInsuranceData={uniprofileInsuranceData}
                                    isKiwiUser={isKiwiUser}
                                    handleGetPricesNRange={handleGetPricesNRange}
                                    generatePrices={generatePrices}
                                    isOps={isOps}
                                    providerId={providerId}
                                    isAdd={isAdd}
                                    allStatesFromService={allStatesFromService}
                                    //todo need add from removed from service and in editing?
                                    allowStates={choosedStates}
                                    serviceType={item.serviceType}
                                    serviceTypeTemplate={item}
                                    serviceTypeTemplateValue={value}
                                    allStateConfigTypePriceData={allStateConfigTypePriceData}
                                    service={current}
                                    allEditingNames={allNames}
                                    onNameIsExistedError={(isExisted: boolean) => {
                                        nameIsExistedError.current[inx] = isExisted;
                                        const hasError = nameIsExistedError.current.filter((val) => !!val).length > 0;
                                        onHasNameErrorUpdate?.(!!hasError);
                                    }}
                                    forceDetectMedicationFlag={errorMedicationFlag}
                                    defaultOpen={defaultOpen || isAdd}
                                    onServiceTypeInfoUpdate={(info: ServerKlarityService) => {
                                        pendingServerKlarityServices.current[inx] = info;
                                        setPendingServerKlarityServicesFlag({});
                                    }}
                                    onDisabled={(disabled: boolean) => {
                                        pendingDisabledIds.current[inx] = disabled;
                                        setPendingDisabledIdsFlag({});
                                    }}
                                    editValue={editValue}
                                    onRemove={() => {
                                        const deleteInx =
                                            inx - (allConfigingServiceTypes.length - addedServiceTypes.length);
                                        const _addedServiceTypes = [...addedServiceTypes];
                                        _addedServiceTypes.splice(deleteInx, 1);
                                        delete pendingServerKlarityServices.current[inx];
                                        delete pendingDisabledIds.current[inx];
                                        setPendingDisabledIdsFlag({});
                                        setAddedServiceTypes(_addedServiceTypes);
                                    }}
                                    addressList={addressList}
                                    onInitVisitStateChange={handleInitVisitStateChange}
                                    servicePriceConfig={servicePriceConfig}
                                    useInsuranceComponent={useInsuranceComponent}
                                />
                            </div>
                        );
                    })}
                    {supportAddNew && (
                        <div className={s.addNew}>
                            <div className={s.left}>
                                <div className={s.label}>Add another service as</div>
                                <div className={s.selectWrap}>
                                    <Select
                                        labelInValue
                                        value={pendingAddServiceOption}
                                        className={s.select}
                                        onChange={(v: any) => {
                                            if (v.label === '🕒 New patient initial visit (15 min)') {
                                                setIsWeightLoss15Mins(true);
                                            } else {
                                                setIsWeightLoss15Mins(false);
                                            }
                                            setPendingAddServiceOption(v);
                                            // setPendingAddServiceType(v.value);
                                        }}
                                    >
                                        {optionServiceTypes?.map((val: KlarityServiceTypeTemplate) => {
                                            return (
                                                <Select.Option
                                                    key={val.serviceType}
                                                    // value={val.serviceType}
                                                    value={val.displayName}
                                                >
                                                    {val.displayName || val.serviceType}
                                                </Select.Option>
                                            );
                                        })}
                                    </Select>
                                </div>
                            </div>
                            <div className={s.addBtn}>
                                <Button
                                    onClick={() => {
                                        if (pendingAddServiceOption) {
                                            const addTemplate: KlarityServiceTypeTemplate | undefined =
                                                optionServiceTypes.find(
                                                    (item) => item.serviceType === pendingAddServiceOption.key,
                                                );
                                            if (addTemplate) {
                                                const addTemplateClone = { ...addTemplate };
                                                if (isWeightLoss15Mins) {
                                                    addTemplateClone.klarityTemplate = WEIGHT_LOSS_15_MINS_TEMPLATE;
                                                    addTemplateClone.displayName =
                                                        '🕒 New patient initial visit (15 min) 23';
                                                    addTemplateClone.description =
                                                        'An initial visit with a provider typically includes a medical history review, an assessment of your specific symptoms and concerns, and a visit notes — all completed within a 15-minute session.';
                                                    // addTemplate.customizedServiceName = 'Consultation and Prescription';
                                                }
                                                const _newAdded: KlarityServiceTypeTemplate[] = [...addedServiceTypes];
                                                _newAdded.push(addTemplateClone);
                                                setAddedServiceTypes(_newAdded);
                                                // setPendingAddServiceType(optionServiceTypes?.[0]?.serviceType);
                                                pendingDisabledIds.current[allConfigingServiceTypes.length] = false;
                                            }
                                            // setPendingAddServiceType(undefined);
                                        }
                                    }}
                                    className={s.btn}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="17"
                                        height="17"
                                        viewBox="0 0 17 17"
                                        fill="none"
                                    >
                                        <path
                                            d="M8.50033 3.63672V14.3034M13.8337 8.97005L3.16699 8.97005"
                                            stroke="#111827"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                    <span>Add</span>
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <Modal
                open={showProgramModal && isLayer}
                width={1200}
                className={`${commonS.modalFixHeightWrap} ${s.modalWrap}`}
                cancelButtonProps={{
                    style: { display: 'none' },
                }}
                onCancel={() => {
                    setShowProgramModal(false);
                }}
                okText="Close"
                onOk={() => {
                    setShowProgramModal(false);
                }}
                title={programModalShowWebinar ? 'Discover more about the program in our next webinar' : null}
            >
                {programModalShowWebinar && (
                    <div className={s.sModalWrap}>
                        <div className={s.content}>
                            <div className={s.calendlyWrapOut}>
                                <div className={s.des}>
                                    Interested in learning more before deciding? Join our next webinar to discover how
                                    the Klarity Select Weight Loss Program can benefit your practice. Register now to
                                    secure your spot!
                                </div>
                                <div id="calendly" className={s.calendlyWrap} />
                            </div>
                        </div>
                    </div>
                )}
                {!programModalShowWebinar && (
                    <div className={s.modalWrapIn}>
                        <ProgramConfigIntro
                            program={program}
                            onClickReview={() => {
                                setShowProgramModal(false);
                            }}
                            handleShowJoinWebinar={() => {
                                handleOpenCalendarInModal();
                            }}
                        />
                    </div>
                )}
            </Modal>
        </div>
    );
};

export default ConfigService;
